<div class="content-block light-control-host" id="application-creator-content">
  <form [formGroup]="applicationResourcesModel" (ngSubmit)="saveApplication()">
    <div class="header-container">
      <div>
        <h1>Select Application Resources</h1>
        <div>
          Choose resources by setting tag or type rules, or select manually from the Available Resources list.
          Dependencies will be automatically included.
        </div>
      </div>
      <div class="flex-center-row form-controls">
        @if (!saving) {
          <div class="flex-center-row margin-top">
            <div class="spacer"></div>
            <button type="button" class="arpio-secondary-button" (click)="backButtonClick()">BACK</button>
            <button type="submit" class="arpio-button margin-left" [disabled]="!applicationResourcesModel.valid">
              FINISH
            </button>
          </div>
        } @else {
          <div class="flex-center-row margin-top">
            <div class="spacer"></div>
            <h1><i class="fa-solid fa-spinner fa-spin"></i></h1>
          </div>
        }
      </div>
    </div>
    <ng-container *ngLet="accountIntegrations as accountInts">
      @if (accountInts.length > 0) {
        <div class="flex-center-row control-header">
          <h3 class="spacer">Application Add Ons</h3>
        </div>
        <application-integrations-form-control
          formControlName="applicationIntegrationIds"
          [accountIntegrations]="accountInts"
        ></application-integrations-form-control>
      }
    </ng-container>

    <app-resource-selection
      [formGroup]="applicationFormModel"
      [possibleTagValues]="possibleTagValues"
      [possibleResourceTypes]="possibleResourceTypes | async"
      [possibleResourceGroups]="possibleResourceGroups"
      [applicationType]="applicationType"
      [resources]="resources"
      [inclusionRulesCount$]="inclusionRulesCount$"
      [exclusionRulesCount$]="exclusionRulesCount$"
      [includeRulesOpen]="includeRulesOpen"
      [excludeRulesOpen]="excludeRulesOpen"
      [shouldObscureExclusionRules]="shouldObscureExclusionRules"
      [refreshing]="refreshing"
      [filterText]="filterText"
      [rpo]="rpo"
      [showRescanButton]="true"
      (toggleIncludeRules)="toggleIncludeConditions()"
      (toggleExcludeRules)="toggleExcludeConditions()"
      (toggleExclusionRulesEnabled)="toggleExclusionRules()"
      (filterChange)="doFilterResources($event)"
      (refreshClick)="refreshButtonClick()"
    >
    </app-resource-selection>
  </form>
</div>
